import { render, staticRenderFns } from "./serverManagement.vue?vue&type=template&id=e42acfd0&scoped=true&"
import script from "./serverManagement.vue?vue&type=script&lang=js&"
export * from "./serverManagement.vue?vue&type=script&lang=js&"
import style0 from "./serverManagement.vue?vue&type=style&index=0&id=e42acfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42acfd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e42acfd0')) {
      api.createRecord('e42acfd0', component.options)
    } else {
      api.reload('e42acfd0', component.options)
    }
    module.hot.accept("./serverManagement.vue?vue&type=template&id=e42acfd0&scoped=true&", function () {
      api.rerender('e42acfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/serverManagement.vue"
export default component.exports